export const hexToBytes = (hex: string): number[] => {
    const str = hex.replace('0x', '');
    for (var bytes = [], c = 0; c < str.length; c += 2)
        bytes.push(parseInt(str.substr(c, 2), 16));
    return bytes;
};
